import styled from "styled-components";
import { ArrowScroll, Text, Icon } from "../../../services/visualLibraryService";
import { detailBackgroundStyled } from "../../../styles/shared-styles";
import { directions } from "../../../services/i18nService";

export const DetailPageStyled = styled.section`
  padding: ${props => (props.isSeries ? "3.5" : "6")}% ${props => props.theme.baseLayoutPaddingBs}%;
  padding-${props => (props.theme.locale.dir === directions.RIGHT_TO_LEFT ? "left" : "right")}: 0; 
  padding-bottom: 0;
`;

export const DetailContainerStyled = styled.div`
  width: 100%;
  height: 100%;
  ${detailBackgroundStyled.styles};
  will-change: transform;
  transform: ${props => `translateY(${props.position}px)`};
  transition: transform 0.2s linear;
`;

export const DetailWrapperStyled = styled.div`
  width: 100%;
  height: 100%;
  ${detailBackgroundStyled.styles};
`;

export const ArrowScrollStyled = styled(ArrowScroll)`
  position: absolute;
  left: 50%;
  bottom: 5%;
  transform: translateX(-50%);
`;

export const DisclaimerText = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: ${props => props.theme.components.detail.disclaimer.margin.top || props.theme.spacing.xmedium};
`;

export const IconStyled = styled(Icon)`
  width: ${props => props.theme.components.detail.disclaimer.icon.width};
  height: ${props => props.theme.components.detail.disclaimer.icon.height};
  fill: ${props => props.theme.components.detail.disclaimer.icon.color || props.theme.color.cyan};
`;

export const DisclaimerTextStyled = styled(Text)`
  font-size: ${props => props.theme.components.detail.disclaimer.fontSize || props.theme.font.size.small};
  ${props =>
    `margin-${props.theme.locale.dir === "rtl" ? "right" : "left"}: ${
      props.theme.components.detail.disclaimer.margin.left
    }`};
  line-height: ${props => props.theme.components.detail.disclaimer.lineHeight || props.theme.font.lineHeight.small};
`;
